export { SSRSafeJSMCookieConsentBanner as JSMCookieConsentBanner } from './jsm-cookie-consent-banner';
